import React, {useState, useEffect} from 'react'
import { Section, ProjectSnapCard } from '../ui'


export default function P5jsBrowse(props) {
  const [projects, setProjects] = useState();
  const [fetched, setFetched] = useState(false);
  
  useEffect(() => {
    if(!fetched){
      const dummyProjects = {
        id: 'swavikasp5js',
        data: [
          {
            id: 'p5js10042020',
            title:'Escape through space',
            desc:'Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
            timestamp:'09/04/2020',
            bgImgUrl:'https://images.unsplash.com/photo-1518495973542-4542c06a5843?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=300&q=120',
            bgColor:'black',
            color:'wheat' 
          },
          {
            id: 'p5js11042020',
            title:'Crack the break',
            desc:'Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
            timestamp:'09/04/2020',
            bgImgUrl:'https://images.unsplash.com/photo-1518495973542-4542c06a5843?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=300&q=120',
            bgColor:'pink',
            color:'black' 
          }
        ],
        count: 2
      }
      setProjects(dummyProjects);
      setFetched(true);
    }
  }, [fetched]);
  
  useEffect(() => {
    console.log('P5jsAll[props]::', props)
  });
  const {history} = props;
  return (
    <div className="sw-pad">
      <Section label={"P5 js"}>
        {
          projects && projects.data && projects.data.map(project => {
            return <ProjectSnapCard
                      key={project.id}
                      onClick={() => {history && history.push(`/p5js/id=${project.id}`)}}
                      title={project.title}
                      desc={project.desc}
                      timestamp={project.timestamp}
                      bgImgUrl={project.bgImgUrl}
                      bgColor={project.bgColor}
                      color={project.color} />
          })
        }
      </Section>
    </div>
  )
}
